<template>
    <el-scrollbar class="literacy-ranking-detail">
        <div class="detail-box">
            <div class="detail-box_header">素养考核</div>

            <div class="detail-box_operate">
                <div class="operate-filter">
                    <div class="operate-filter_label">选择学生:</div>

                    <el-select v-model="s_id" placeholder="请选择" @change="handleStudentChange">
                        <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name" :value="item.s_id"> </el-option>
                    </el-select>
                </div>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <div class="detail-box_content">
                <div class="literacy-item" v-for="(item, index) in literacyList" :key="item.key">
                    <div class="literacy-item_title">{{ index + 1 }}、{{ item.name }}</div>

                    <div class="literacy-item_children">
                        <div class="children-item" v-for="childItem in item.chirldren" :key="childItem.key">
                            <div class="item-label">{{ childItem.name }}</div>

                            <div class="item-score">
                                {{ childItem.score }}
                                <span>{{ !childItem.score ? "-" : "" }}分</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "LiteracyRankingDetail",
    data() {
        return {
            studentList: [],
            literacyList: [],
            s_id: Number(this.$route.query.s_id),
        };
    },
    created() {
        this.getStudentList();
        this.getLiteracyDetail();
    },
    methods: {
        getStudentList() {
            // showStudent
            const params = {
                type: "all",
                c_id: Number(this.$route.query.class_id),
                s_id: Number(this.$route.query.s_id),
            };

            this.$shttp.axiosGetBy(this.$api.showStudent, params, (res) => {
                if (res.code === 200) {
                    this.studentList = res.data;
                }
            });
        },

        getLiteracyDetail() {
            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(this.$route.query.zhangIndex),
                course_node: Number(this.$route.query.jieIndex),
                s_id: this.s_id,
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_quality_detail, params, (res) => {
                if (res.code === 200) {
                    this.literacyList = res.data.list || [];

                    this.literacyList = this.literacyList.filter((item) => {
                        return item.chirldren && item.chirldren.length > 0;
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleStudentChange(s_id) {
            this.s_id = s_id;

            this.getLiteracyDetail();
        },
    },
};
</script>

<style lang="scss" scoped>
.literacy-ranking-detail {
    width: 100%;
    height: calc(100vh - 70px);
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .detail-box {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 24px 40px;
        box-sizing: border-box;
        min-height: 500px;

        &_header {
            height: 24px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 800;
            font-size: 24px;
            color: #333333;
            line-height: 24px;
        }

        &_operate {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;

            .operate-filter {
                display: flex;
                align-items: center;
                gap: 20px;

                &_label {
                    height: 30px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 30px;
                }

                ::v-deep .el-input__inner {
                    background-color: transparent !important;
                }
            }

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }
        }

        &_content {
            margin-top: 20px;
            display: flex;
            gap: 20px;
            flex-wrap: wrap;

            .literacy-item {
                width: calc((100% - 40px) / 3);
                height: 272px;
                background-color: #f2f6fa;
                border-radius: 4px;
                border: 1px solid #ededed;
                box-sizing: border-box;
                padding: 20px 24px;

                &_title {
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 20px;
                    color: #333333;
                }

                &_children {
                    margin-top: 30px;
                    width: 100%;

                    .children-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 30px;

                        &:not(.children-item:first-of-type) {
                            margin-top: 18px;
                        }

                        .item-label {
                            height: 20px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }

                        .item-score {
                            height: 30px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 500;
                            font-size: 32px;
                            color: #333333;
                            line-height: 30px;

                            span {
                                color: #999999;
                                font-size: 14px;
                                line-height: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
